import { Adapter } from '../../../interfaces/adapter';
import { Injectable } from '@angular/core';

export class AdunitStats {
	public label: string;
	public value: string;

	public inits: number;
	public inview: number;
	public inview_compare: number;
	public placement_failed: number;
	public placement_failed_compare: number;
	public inits_compare: number;
	public creative_inits: number;
	public creative_inits_compare: number;
	public views: number;
	public views_compare: number;
	public clicks: number;
	public clicks_compare: number;
	public creative_fillrate: number;
	public creative_fillrate_compare: number;
	public fillrate: number;
	public fillrate_compare: number;
	public fillrateInview: number;
	public fillrateInview_compare: number;
	public placementFailedRate: number;
	public placementFailedRate_compare: number;
	public placementRate: number;
	public placementRate_compare: number;
	public clickrate: number;
	public clickrate_compare: number;

	constructor(
		inits: number,
		inview: number,
		inview_compare: number,
		placement_failed: number,
		placement_failed_compare: number,
		inits_compare: number,
		creative_inits: number,
		creative_inits_compare: number,
		views: number,
		views_compare: number,
		clicks: number,
		clicks_compare: number,
		creative_fillrate: number,
		creative_fillrate_compare: number,
		fillrate: number,
		fillrate_compare: number,
		fillrateInview: number,
		fillrateInview_compare: number,
		placementFailedRate: number,
		placementFailedRate_compare: number,
		placementRate: number,
		placementRate_compare: number,
		clickrate: number,
		clickrate_compare: number
	) {

		this.inits = inits;
		this.inview = inview;
		this.inview_compare = inview_compare;
		this.placement_failed = placement_failed;
		this.placement_failed_compare = placement_failed_compare;
		this.inits_compare = inits_compare;
		this.creative_inits = creative_inits;
		this.creative_inits_compare = creative_inits_compare;
		this.views = views;
		this.views_compare = views_compare;
		this.clicks = clicks;
		this.clicks_compare = clicks_compare;
		this.creative_fillrate = creative_fillrate;
		this.creative_fillrate_compare = creative_fillrate_compare;
		this.fillrate = fillrate;
		this.fillrate_compare = fillrate_compare;
		this.fillrateInview = fillrateInview;
		this.fillrateInview_compare = fillrateInview_compare;
		this.placementFailedRate = placementFailedRate;
		this.placementFailedRate_compare = placementFailedRate_compare;
		this.placementRate = placementRate;
		this.placementRate_compare = placementRate_compare;
		this.clickrate = clickrate;
		this.clickrate_compare = clickrate_compare;
	}
}

@Injectable()
export class AdunitStatsAdapter implements Adapter<AdunitStats> {
	adapt(item: any): AdunitStats {
		return new AdunitStats(
			item.inits,
			item.inview,
			item.inview_compare,
			item.placement_failed,
			item.placement_failed_compare,
			item.inits_compare,
			item.creative_inits,
			item.creative_inits_compare,
			item.views,
			item.views_compare,
			item.clicks,
			item.clicks_compare,
			item.creative_fillrate,
			item.creative_fillrate_compare,
			item.fillrate,
			item.fillrate_compare,
			item.fillrateInview,
			item.fillrateInview_compare,
			item.placementFailedRate,
			item.placementFailedRate_compare,
			item.placementRate,
			item.placementRate_compare,
			item.clickrate,
			item.clickrate_compare,
		);
	}
}
